export default "__VITE_ASSET__DCuFlpVm__"